export default "__VITE_ASSET__6VGl4HZ6__"